import {
    startSpeedDetection,
    getScrollSpeed,
    speedUnits,
} from '@spt-advertising/adi-scroll-speed-detection';
import InscreenObserver from '@finn-no/inscreen-observer';

export default {
    dependencies: ['$element', 'bannerastservice', 'radio', 'sitesettings'],
    callable(element, bannerastService, radio, siteSettings) {
        let delayed = false;
        let retries = 0;
        const bannerElement = element.getAttribute('data-astbanner-name')
            ? element
            : element.querySelector('div[data-astbanner-name]');

        const speedThreshold = 1.3;
        const delayMs = 200;

        const lazyLoadBanners = siteSettings.lazyLoadBanners === 'true';
        const hasInscreenThreshold = Boolean(
            bannerElement.getAttribute('data-inscreen-threshold')
        );

        let inscreenObserver;

        if (lazyLoadBanners) {
            startSpeedDetection();
        }

        if (lazyLoadBanners && hasInscreenThreshold) {
            observeAndLazyLoadBanner();
        } else {
            showBanner();
        }

        function observeAndLazyLoadBanner() {
            inscreenObserver = createInscreenObserver();
            observeBanner();
        }

        function createInscreenObserver() {
            const proximity =
                parseInt(
                    bannerElement.getAttribute('data-inscreen-threshold')
                ) || 0;
            return new InscreenObserver(lazyLoadBannerCallback, { proximity });
        }

        function lazyLoadBannerCallback() {
            if (getScrollSpeed(speedUnits.VIEWPORTS) < speedThreshold) {
                showBanner();
                unobserveBanner();
            } else if (!delayed) {
                setTimeout(() => {
                    if (retries < 5) {
                        retries++;
                        if (retries > 4) {
                            delayed = true;
                        }
                        lazyLoadBannerCallback();
                    }
                }, delayMs);
            }
        }

        function observeBanner() {
            inscreenObserver.observe(element);
            radio('pre-filter-and-search-changed').subscribe(unobserveBanner);
        }

        function unobserveBanner() {
            inscreenObserver.unobserve(element);
            radio('pre-filter-and-search-changed').unsubscribe(unobserveBanner);
        }

        function showBanner() {
            bannerastService.showBanner(bannerElement.getAttribute('id'));
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/bannerShowBanner.js